import styled from 'styled-components';
import React from 'react';
import { borderRadius } from 'polished';
import CategorySiteAutocomplete from '../../js/components/category-site-autocomplete';
import { Input } from '../';
import PropTypes from 'prop-types';

const renderInput = inputProps => (
  <Input
    {...inputProps}
    type="text"
    style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
    placeholder="I'm looking for... (e.g Plumber)"
    width={270}
  />
);

const Autocomplete = ({ onChange, value, onPostcodeSelected, className }) => (
  <div className={className}>
    <CategorySiteAutocomplete
      focusInputOnSuggestionClick={false}
      onChange={onChange}
      classPrefix={className}
      value={value}
      onSuggestionSelected={onPostcodeSelected}
      renderInputComponent={renderInput}
    />
  </div>
);

Autocomplete.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  onPostcodeSelected: PropTypes.func,
  className: PropTypes.string
};

Autocomplete.defaultProps = {
  classPrefix: ''
};

const Styled = styled(Autocomplete)`
  & {
    display: inline-block;
    &__container {
      display: inline-block;
    }

    &__suggestions-container {
      display: none;
    }

    &__input {
      border-bottom-right-radius: 0 !important;
      border-top-right-radius: 0 !important;
    }

    &__container--open &__input {
      border-bottom-left-radius: 0 !important;
    }

    &__container--open &__suggestions-container {
      text-align: left;
      color: ${props => props.theme.back};
      position: absolute;
      width: 439px;
      border: 0;
      top: 42px;
      left: -1px;
      background-color: ${props => props.theme.snow};
      border: 1px solid #eee;
      border-top: 0;
      ${borderRadius('bottom', '5px')};
      z-index: 3;
    }

    &__container--open &__suggestions-container {
      display: block;
    }

    &__suggestions-list {
      margin: 0;
      padding: 0;
      list-style-type: none;

      li {
        font-size: 16px;
      }
    }

    &__suggestion {
      cursor: pointer;
      padding: 10px 20px;
      margin: 2px;
    }

    &__suggestion--highlighted {
      background-color: ${props => props.theme.primary};
      border-radius: 2px;
      color: ${props => props.theme.snow};
      transition: 0.1s background ease;
    }

    &__section-title {
      padding: 8px 15px;
      border-radius: 2px;
      width: auto;
      background-color: #f9f9f9 !important;
      border-bottom: 0 solid #777;
      text-transform: uppercase;
      color: #999;
    }

    &__section-container:first-child &__section-title {
      border-top: 0;
    }

    .category-site-search__suggestion-highlight {
      font-weight: 600;
    }
  }
`;

export default Styled;
